import { call, put, takeLatest } from "redux-saga/effects";
import {
  editSectionStart,
  editSectionSuccess,
  editSectionFailure,
} from "../reducer";
import { successNotifier } from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { postEdit } from "../../../services/section";

export function* handleEdit({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postEdit, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editSectionSuccess(raw));
    successNotifier("Section edited successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(editSectionFailure(message || raw?.error));
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onEditSection() {
  yield takeLatest(editSectionStart.type, handleEdit);
}
